import React from "react";
import "./CustomToast.css";

/**
 * Minimal & Professional Toast Component
 * Icon-free, Clean Typography & Project Theme Colors
 */
export const CustomToastContent = ({ type = "success", title, message, subtext }) => {
  const getDefaultTitle = () => {
    switch (type) {
      case "save":
        return "Saved successfully";
      case "delete":
        return "Deleted successfully";
      case "download":
        return "Download complete";
      case "error":
        return "Action failed";
      case "warn":
      case "warning":
        return "Notice";
      case "info":
        return "Information";
      case "success":
      default:
        return "Success";
    }
  };

  const displayTitle = title || getDefaultTitle();

  return (
    <div className={`custom-toast-body type-${type}`}>
      <div className="custom-toast-main">
        <div className="custom-toast-title-row">
          <span className="custom-toast-dot" />
          <span className="custom-toast-title">{displayTitle}</span>
        </div>
        {message && <div className="custom-toast-message">{message}</div>}
        {subtext && <div className="custom-toast-subtext">{subtext}</div>}
      </div>
    </div>
  );
};

export default CustomToastContent;
